export function talkGate({ isAuthenticated, isPro }) {
  if (!isAuthenticated) return 'signin';
  if (!isPro) return 'paywall';
  return 'ready';
}

export function canShowVoiceNote(phase) {
  return phase === 'noted';
}
